
export default {
  name: 'HeroSection',
  props: {
    storeName: {
      type: String,
      required: true,
    },
  },
  computed: {
    content() {
      return this.$store.state[this.storeName].heroContent;
    },
    sectionStyle() {
      return {
        backgroundImage: `url('${this.content.image.url}')`,
      };
    },
  },
};
